module.exports = __webpack_public_path__ + "img/jf-btn.b5d22e5c.png";